import { render, staticRenderFns } from "./CompNewsFeaturedNews.vue?vue&type=template&id=4502a701"
import script from "./CompNewsFeaturedNews.vue?vue&type=script&setup=true&lang=js"
export * from "./CompNewsFeaturedNews.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompNewsFeaturedNews.vue?vue&type=style&index=0&id=4502a701&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports